import React from "react";

import { FcGoogle } from "react-icons/fc";
import { BsGoogle } from "react-icons/bs";

import { ButtonLanding } from "../../../components/Buttons";

function LoginGoogle({ children, name }) {
  return (
    <ButtonLanding
      name={name || "Sign in with google"}
      variant={2}
      // iconStart={<BsGoogle style={{ fontSize: "1rem" }} />}
      iconStart={<FcGoogle style={{ fontSize: "1.1rem" }} />}
      disabled
    />
  );
}

export default LoginGoogle;
